<template>
    <div id="app">
        <v-app id="inspire">
            <h2>Indicadores de Capacitación</h2>
            <v-card>
                <div v-html="miHtml"></div>
            </v-card>
        </v-app>
    </div>
</template>

<script>
export default {
    data: (vm) => ({
        miHtml: `<p>
<img border="0" src="images/Training.png" width="249" height="178"></p>
<p><font face="Arial" size="2"><b>G17 = Indicador Anual de Gestión que muestra 
la relación entre los costos de capacitación impartida y los costos de la masa 
Salarial</b><br>
<a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G17.asp">Indicador: G17</a><br>
Objetivo: 203<br>
<br>
<b>G2 = Indicador anual de gestión que muestra la relación entre el total de 
horas invertidas en capacitación con referencia al total de horas trabajadas</b><br>
<a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G2.asp">Indicador: G2</a><br>
<br>
<b>C2A: Indicador anual de cumplimiento de capacitaciones planificadas prioridad 
&quot;A&quot;</b><br>
<a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/C2A_B_C.asp">Indicador: C2A</a><br>
Objetivo: 147<br>
<br>
<b>C2B: Indicador anual de cumplimiento de capacitaciones planificadas prioridad 
&quot;B&quot;</b><br>
<a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/C2A_B_C.asp">Indicador: C2B</a><br>
Objetivo: 147<br>
<br>
<b>C2C: Indicador anual de cumplimiento de capacitaciones planificadas prioridad 
&quot;C&quot;</b><br>
<a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/C2A_B_C.asp">Indicador: C2C</a><br>
Objetivo: 147</font></p>
<p><font face="Arial" size="2"><b>Eficacia de las capacitaciones</b><br>
<a target="_blank" href=" http://192.168.11.201/intranet/desempeño/promedio_capacitacion.asp">Objetivo: 178</a></font></p>
`,
    }),
};
</script>